import { StandardFile } from '../shared/file/file';

export class ResumeDetails {
    first_name: string;
    last_name: string;
    mobile_no: number;
    mobile_no_cc: number;
    email_id: string;
    currency_code: number;
    duration_code: number;
    scale_code: number;
    education_code: number;
    skill_code: any[];
    current_employee: string;
    current_designation: number;
    experience: number;
    files: StandardFile;
    current_location: number;
    amount: string;
    requirement_id: number;
    resume_id: number;
    notice_period: number;
    skill_rating: any[] = [];
    pin_code: number;
    relevant_experience: number;
    constructor(obj = {
        first_name: '',
        last_name: '',
        mobile_no: null,
        mobile_no_cc: null,
        email_id: '',
        currency_code: 0,
        duration_code: 0,
        scale_code: 0,
        education_code: null,
        skill_code: [],
        current_employee: '',
        current_designation: 0,
        experience: null,
        current_location: 0,
        amount: null,
        notice_period: null,
        files: null,
        skill_rating: [],
        pin_code: null,
        relevant_experience: null,
    }) {
        if (obj.files && typeof obj.files == "string" && obj.files != 'null') {
            obj.files = JSON.parse(obj.files);
        }
        else if (obj.files == '' || obj.files == 'null') {
            obj.files = null;
        }
        this.files = obj.files || null;
        this.first_name = obj.first_name || '';
        this.last_name = obj.last_name || '';
        this.mobile_no = obj.mobile_no || '';
        this.mobile_no_cc = obj.mobile_no_cc || 1001;
        this.email_id = obj.email_id || '';
        this.currency_code = obj.currency_code || 0;
        this.duration_code = obj.duration_code || 0;
        this.scale_code = obj.scale_code || 0;
        // if (typeof obj.education_code == "string") {
        //
        //     obj.education_code = JSON.parse(obj.education_code);
        //
        // }
        // this.education_code = obj.education_code || [];
        this.education_code = obj.education_code || null;
        if (typeof obj.skill_code == "string") {

            obj.skill_code = JSON.parse(obj.skill_code);

        }
        this.skill_code = obj.skill_code || [];
        this.current_employee = obj.current_employee || '';
        this.current_designation = obj.current_designation || 0;
        this.experience = obj.experience;
        this.current_location = obj.current_location || 0;
        this.amount = obj.amount || null;
        this.notice_period = obj.notice_period || null;
        this.skill_rating = obj.skill_rating || [];
        this.pin_code = obj.pin_code || null;
        this.relevant_experience = obj.relevant_experience;
    }
    setFormGroupData(obj) {
        this.first_name = obj.first_name || '';
        this.last_name = obj.last_name || '';
        this.mobile_no = obj.mobile_no || '';
        this.mobile_no_cc = obj.mobile_no_cc || 1001;
        this.email_id = obj.email_id || '';
        this.currency_code = obj.currency_code || 0;
        this.duration_code = obj.duration_code || 0;
        this.scale_code = obj.scale_code || 0;
        // if (typeof obj.education_code == "string") {
        //
        //     obj.education_code = JSON.parse(obj.education_code);
        //
        // }
        this.education_code = obj.education_code || null;
        if (typeof obj.skill_code == "string") {

            obj.skill_code = JSON.parse(obj.skill_code);

        }
        this.skill_code = obj.skill_code || [];
        this.current_employee = obj.current_employee || '';
        this.current_designation = obj.current_designation || 0;
        this.experience = obj.experience;
        this.current_location = obj.current_location || 0;
        this.amount = obj.amount || null;
        this.notice_period = obj.notice_period || null;
        this.pin_code = obj.pin_code || null;
        this.relevant_experience = obj.relevant_experience;
    }
    setData(obj) {
        this.first_name = obj.first_name || '';
        this.last_name = obj.last_name || '';
        this.mobile_no = obj.mobile_no || '';
        this.mobile_no_cc = obj.mobile_no_cc || 1001;
        this.email_id = obj.email_id || '';
        this.currency_code = obj.currency_code || 0;
        this.duration_code = obj.duration_code || 0;
        this.scale_code = obj.scale_code || 0;
        // if (typeof obj.education_code == "string") {
        //
        //     obj.education_code = JSON.parse(obj.education_code);
        //
        // }
        this.education_code = obj.education_code || 0;
        if (typeof obj.skill_code == "string") {

            obj.skill_code = JSON.parse(obj.skill_code);

        }
        this.skill_code = obj.skill_code || [];
        this.current_employee = obj.current_employee || '';
        this.current_designation = obj.current_designation || 0;
        this.experience = obj.experience;
        this.current_location = obj.current_location || 0;
        this.amount = obj.amount || null;
        this.notice_period = obj.notice_period || null;
        if (obj.files && typeof obj.files == "string" && obj.files != 'null') {
            obj.files = JSON.parse(obj.files);
        }
        else if (obj.files == '' || obj.files == 'null') {
            obj.files = null;
        }
        this.files = obj.files || null;
        this.resume_id = obj.resume_id || 0;
        this.skill_rating = obj.skill_rating || [];
        this.pin_code = obj.pin_code || null;
        this.relevant_experience = obj.relevant_experience;
    }
    getFormGroupData() {
        return {
            first_name: this.first_name || '',
            last_name: this.last_name || '',
            mobile_no: this.mobile_no || '',
            mobile_no_cc: this.mobile_no_cc || 1001,
            email_id: this.email_id || '',
            currency_code: this.currency_code || 0,
            duration_code: this.duration_code || 0,
            scale_code: this.scale_code || 0,
            education_code: this.education_code || null,
            skill_code: this.skill_code || 0,
            current_employee: this.current_employee || '',
            current_designation: this.current_designation || 0,
            experience: this.experience || 0,
            current_location: this.current_location || 0,
            amount: this.amount || null,
            notice_period: this.notice_period || null,
            pin_code: this.pin_code || null,
            relevant_experience: this.relevant_experience || 0,
        }
    }
    setFile(obj) {
        if (obj.Name) {
            this.first_name = obj.Name;
        }
        if (obj.EMail) {
            this.email_id = obj.EMail;
        }
        if (obj.NoticePeriod) {
            if (typeof obj.NoticePeriod == "string") {

                obj.NoticePeriod = JSON.parse(obj.NoticePeriod);

            }
            this.notice_period = obj.NoticePeriod;
        }
        if (obj.Presentemployer) {
            this.current_employee = obj.Presentemployer;
        }
        if (obj.Totalexperience) {
            if (typeof obj.Totalexperience == "string") {

                obj.Totalexperience = JSON.parse(obj.Totalexperience);

            }
            this.experience = obj.Totalexperience;
        }
        if (obj.Relevantexperience) {
            if (typeof obj.Relevantexperience == "string") {

                obj.Relevantexperience = JSON.parse(obj.Relevantexperience);

            }
            this.relevant_experience = obj.Relevantexperience;
        }
        if (obj.Mobile) {
            this.mobile_no = obj.Mobile;
        }
        this.mobile_no_cc = 1001;
    }

    setLinkedInData(obj) {
        this.first_name = obj.firstName;
        this.last_name = obj.lastName;
        this.email_id = obj.emailAddress;
    }


}
